// https://regex101.com/r/ZKFfzC/3
import { getDemoUsernames } from '~/src/dash/resellers/utils/importResellerConfig';
import {
  FirstAndThirdPartyDashboardCardDataCompareKeys,
  FirstAndThirdPartyDashboardCardDataKeys,
  FirstAndThirdPartyDashboardCardDataTitles,
  IFirstAndThirdPartyDashboardCardDataDisplayItem,
} from '~/src/dash/views/measurement-home-view';
import {
  StreamDashboardCardDataCompareKeys,
  StreamDashboardCardDataKeys,
  StreamDashboardCardDataTitles,
} from '~/src/dash/views/networks/constants';

export const REGEX_EMAIL =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const REGEX_NUMERIC = /^[0-9]*$/;

export function onlyNumeric(s: string): boolean {
  return !!s && REGEX_NUMERIC.test(s);
}

export const DEMO_ACCOUNTS = getDemoUsernames();

export const APS_BIDDERS = ['apsOpenAuction', 'apsPMP', 'apsGuarantee'];
{
  /*  hide the toggle Podded Requests for Xandr aka appnexus (un-hide in q1 when xandr is compliant with 2.6.) */
}
export const BIDDERS_PODDED_REQUEST_ENABLED = [
  'amazonORTB',
  'appnexus',
  'beachfront',
  'column6',
  'connatix',
  'dynamicGateway',
  'dynamicPlatformConnection',
  'elementaltv',
  'finecast',
  'freewheelssp',
  'gateway',
  'gatewayTier0',
  'improvedigital',
  'indexExchange',
  'inmobi',
  'magnitectv',
  'mobilefuse',
  'nexstar',
  'openx',
  'platformConnection',
  'premion',
  'pubmatic',
  'publica',
  'rhythmone',
  'sabio',
  'samsung ssp test',
  'samsung ssp',
  'samsungAdManager',
  'samsungDSP',
  'samsungssp',
  'samsungssptest',
  'sharethrough',
  'smaato',
  'smartadserver',
  'smartclip',
  'smartstream',
  'sovrn',
  'stroer',
  'tappx',
  'teads',
  'thetradedesk',
  'triplelift',
  'vibe',
  'videoHeroesRevShare',
  'videoHeroesFixedCPM',
  'videobyte',
  'vrtcal',
  'wurl',
];

export const ORTB26_ENABLED_BIDDERS = [
  'amazonORTB',
  'appnexus',
  'column6',
  'connatix',
  'elementaltv',
  'finecast',
  'freewheelssp',
  'improvedigital',
  'indexExchange',
  'inmobi',
  'marketingarchitects',
  'mobilefuse',
  'nexstar',
  'openx',
  'premion',
  'pubmatic',
  'rhythmone',
  'sabio',
  'samsungAdManager',
  'sharethrough',
  'smaato',
  'smartclip',
  'smartstream',
  'sovrn',
  'stroer',
  'tappx',
  'teads',
  'thetradedesk',
  'triplelift',
  'undertone',
  'vibe',
  'videobyte',
  'vrtcal',
  'wurl',
] as string[];

export const ORTB26_ENABLED_PODDED_TYPE_DYNAMIC_BIDDERS = [
  'amazonORTB',
  'appnexus',
  'column6',
  'connatix',
  'elementaltv',
  'finecast',
  'freewheelssp',
  'improvedigital',
  'indexExchange',
  'inmobi',
  'mobilefuse',
  'nexstar',
  'openx',
  'pubmatic',
  'rhythmone',
  'sabio',
  'samsungAdManager',
  'smaato',
  'smartclip',
  'sovrn',
  'stroer',
  'tappx',
  'teads',
  'thetradedesk',
  'triplelift',
  'videobyte',
  'vrtcal',
  'wurl',
] as string[];

export const ORTB26_ENABLED_PODDED_TYPE_STRUCTURED_BIDDERS = [
  'amazonORTB',
  'appnexus',
  'connatix',
  'elementaltv',
  'finecast',
  'freewheelssp',
  'improvedigital',
  'indexExchange',
  'inmobi',
  'mobilefuse',
  'openx',
  'premion',
  'pubmatic',
  'rhythmone',
  'sabio',
  'samsungAdManager',
  'sharethrough',
  'smartstream',
  'sovrn',
  'tappx',
  'teads',
  'thetradedesk',
  'triplelift',
  'vibe',
  'vrtcal',
  'videobyte',
] as string[];

export const ORTB26_ENABLED_PODDED_TYPE_HYBRID_BIDDERS = [
  'connatix',
  'inmobi',
  'pubmatic',
  'rhythmone',
  'samsungAdManager',
  'sovrn',
  'tappx',
  'vrtcal',
  'teads',
] as string[];

export const BIDDERS_MULTI_BID_ENABLED = [
  'magnitectv',
  'spotx',
  'verizon', // for yahoo demand source in dropdown
];

export const BIDDERS_ADBREAK_TARGETING_ENABLED = ['publica'];

export const BIDDERS_WITHOUT_BID_ADJUSTMENT_FACTOR = [
  'samsung ssp test',
  'samsungssptest',
  'samsung ssp',
  'samsungssp',
];

export const ALL_PLATFORM_CONNECTION_BIDDERS = [
  'dynamicGateway',
  'dynamicPlatformConnection',
  'gateway',
  'gatewayTier0',
  'platformConnection',
  'videoHeroesRevShare',
  'videoHeroesFixedCPM',
];

export const FIXED_PRICE_PLATFORM_CONNECTION_BIDDERS = [
  'gateway',
  'gatewayTier0',
  'platformConnection',
  'videoHeroesFixedCPM',
];

export const DYNAMIC_PLATFORM_CONNECTION_BIDDERS = [
  'dynamicGateway',
  'dynamicPlatformConnection',
  'videoHeroesRevShare',
];

export const BIDDERS_SHARE_OF_VOICE_TYPE_ENABLED = [
  'dynamicGateway',
  'dynamicPlatformConnection',
  'gateway',
  'gatewayTier0',
  'platformConnection',
  'publica',
  'videoHeroesRevShare',
  'videoHeroesFixedCPM',
];

// update DisabledSecondaryRequestBidders in platform with this array
export const NO_SECONDARY_REQUEST_BIDDERS = [
  'apsGuarantee',
  'apsPMP',
  'apsOpenAuction',
  'dynamicGateway',
  'dynamicPlatformConnection',
  'freewheel',
  'gateway',
  'gatewayTier0',
  'platformConnection',
  'publicaCampaign',
  'publica',
  'rokuHB',
  'samsungssp',
];

// ---------------------- Home dashboard -----------------------------

export type HomeDashboardCardDataTitles =
  | 'Revenue'
  | 'Impressions'
  | 'CPM'
  | 'Endpoint Requests'
  | 'Render Rate'
  | 'Pod Fill Rate'
  | 'CPM Per Second'
  | 'Auctions'
  | 'Fill Rate'
  | 'Bid Requests'
  | 'Bid Responses'
  | 'Winning Bids'
  | 'Bid Response Rate'
  | 'Bid Timeout Rate'
  | 'Pod Clear Rate'
  | 'Paid Pod Clear Rate'
  | 'Endpoint Request eCPM';

export type IHomeDashboardCardDataDisplay = Record<
  HomeDashboardCardDataTitles,
  IHomeDashboardCardDataDisplayItem
>;

interface IHomeDashboardCardDataDisplayItem {
  value: string;
  sign: number;
}

// ---------------------- Network dashboard -----------------------------

// ---------------------- Measurement Dashboard -----------------------------
export type IMeasurementAggregateCardDataDisplay = Record<
  FirstAndThirdPartyDashboardCardDataTitles,
  IFirstAndThirdPartyDashboardCardDataDisplayItem
>;

// ---------------------- Dashboard Unions -----------------------------
export interface ISelectedMetric {
  key: DashboardCardDataTitles;
  active: boolean;
}
export type DashboardCardDataTitles =
  | StreamDashboardCardDataTitles
  | FirstAndThirdPartyDashboardCardDataTitles
  | HomeDashboardCardDataTitles;
export type DashboardCardDataKeys =
  | StreamDashboardCardDataKeys
  | FirstAndThirdPartyDashboardCardDataKeys;
export type DashboardCardDataCompareKeys =
  | StreamDashboardCardDataCompareKeys
  | FirstAndThirdPartyDashboardCardDataCompareKeys;

// ---------------------- Misc -----------------------------
export const CreativeTypeMediafile: string = 'mediafile';
export const CreativeTypeVast: string = 'vast';
export const WeightingTypeRequests: string = 'Requests count';
export const WeightingTypeImps: string = 'Imps count';

// ---------------------- Live Data ------------------------
export const DensityRangeHourByHour = 1;
export const DensityRange15Minutes = 15;
export const DensityRange30Minutes = 30;
export const DensityRange1HourByMinutes = 60;
export const DensityRange4HoursByHour = 4;
export const DensityRange4HoursByMinutes = 240;
export const DensityRange6HoursByMinutes = 360;
export const DensityRange12HoursByHour = 12;
export const DensityRange12HoursByMinutes = 720;
export const DensityRange24HoursByHour = 24;
export const DensityRange24HoursByMinutes = 1440;
export const DensityRangeWeekByHour = 168;

export interface IDensityRange {
  text: string;
  value: number;
}
